<app-navigation></app-navigation>
<app-maintenance></app-maintenance>
<div class="mainContentFullWith unselectable">
  <div class="unselectable headerTitle headline">Übersicht</div>
  <div class="breakLine"></div>
  <div id="moduleContent">
    <ejs-grid #damageAdministrationOverviewGrid
      id="damageAdministrationOverviewGrid"
      (recordDoubleClick)="onRecordDoubleClick($event)"
      [locale]="locale"
      [dataSource]="dataSource"
      [toolbar]="toolbar"
      (toolbarClick)="toolbarClick($event)"
      (rowDataBound)="rowDataBound($event)">
      <e-columns>
        <e-column field="Id" headerText="Nr." textAlign="Left" isPrimaryKey="true"></e-column>
        <e-column field="DamageDate" headerText="Schadendatum" textAlign="Left"></e-column>
        <e-column field="ReceiverName" headerText="Empfänger" textAlign="Left" [filter]="{ operator: 'contains' }"></e-column>
        <e-column field="WorkshopName" headerText="Rep. Werkstatt" textAlign="Left" [filter]="{ operator: 'contains' }"></e-column>
        <e-column field="CausedByName" headerText="Verursacher" textAlign="Left" [filter]="{ operator: 'contains' }"></e-column>
        <e-column field="InsuranceName" headerText="Versicherungsart" textAlign="Left" [filter]="{ operator: 'contains' }"></e-column>
        <e-column field="OwnCosts" headerText="Eigenkosten" textAlign="Right" format="N2"></e-column>
        <e-column field="ChassisNo" headerText="Chassis Nr." textAlign="Left" [filter]="{ operator: 'contains' }"></e-column>
        <e-column field="Identification" headerText="Identifikation" textAlign="Left" [filter]="{ operator: 'contains' }"></e-column>
        <e-column field="License" headerText="Kontrollschild" textAlign="Left" [filter]="{ operator: 'contains' }"></e-column>
        <e-column field="JobTypeName" headerText="Auftragstyp" textAlign="Left" [filter]="{ operator: 'contains' }"></e-column>
        <e-column field="CarBrandName" headerText="Marke" textAlign="Left" [filter]="{ operator: 'contains' }"></e-column>
        <e-column field="CarTypeName" headerText="Fahrzeugtyp" textAlign="Left" [filter]="{ operator: 'contains' }"></e-column>
        <e-column field="CreatedBy" headerText="Erstellt von" textAlign="Left" [filter]="{ operator: 'contains' }"></e-column>
        <e-column field="DamageAmount" headerText="Schadenbetrag" textAlign="Left" [filter]="{ operator: 'contains' }"></e-column>
        <e-column field="InternalStateName" headerText="Status" textAlign="Left" [filter]="{ operator: 'contains' }"></e-column>
        <e-column field="FeedState" headerText="Aktivität" textAlign="Left" [template]="feedStateTemplate">
          <ng-template #feedStateTemplate let-data>
            <i *ngIf="data.FeedState === 2" class="bi bi-chat-dots-fill gridIcon"></i>
          </ng-template>
        </e-column>
        <e-column field="LastChangeBy" headerText="Bearbeitet von" textAlign="Left" [filter]="{ operator: 'contains' }"></e-column>
      </e-columns>
    </ejs-grid>
  </div>
</div>
<app-footer></app-footer>